/**
 * Task O: the native store app (收银 / 顾客 / 业绩 / 打卡 / 作品照 / 预约 / 钱箱) and the owner web 团队 → 考勤 list.
 * One row per key: [key, English, 中文]. The app ships English + 中文 only; Malay falls back to English.
 */
const ROWS = [
  ["to.nav.pos", "POS", "收银"],
  ["to.nav.customers", "Customers", "顾客"],
  ["to.nav.performance", "Performance", "业绩"],
  ["to.nav.clock", "Attendance", "打卡"],
  ["to.nav.photos", "Work photos", "作品照"],
  ["to.nav.appointments", "Appointments", "预约"],
  ["to.nav.cash", "Cash drawer", "钱箱"],
  ["to.nav.attendance", "Attendance", "考勤"],
  ["to.perf.title", "My performance", "我的业绩"],
  ["to.perf.today", "Today", "今天"],
  ["to.perf.week", "This week", "本周"],
  ["to.perf.month", "This month", "本月"],
  ["to.perf.sales", "Sales performance", "业绩"],
  ["to.perf.commission", "Commission (estimate)", "提成（预估）"],
  ["to.perf.orders", "{n} sales", "{n} 单"],
  ["to.perf.team", "Team", "团队"],
  ["to.perf.staff", "Staff", "员工"],
  ["to.perf.total", "Total", "合计"],
  ["to.perf.hint", "Commission is an estimate until payroll is approved.", "工资审批前，提成均为预估。"],
  ["to.att.title", "Attendance", "打卡"],
  ["to.att.me", "My shift", "我的班次"],
  ["to.att.notIn", "Not clocked in", "未上班打卡"],
  ["to.att.inSince", "Clocked in since {time}", "{time} 上班"],
  ["to.att.onBreak", "On break since {time}", "{time} 开始休息"],
  ["to.att.clockIn", "Clock in", "上班打卡"],
  ["to.att.clockOut", "Clock out", "下班打卡"],
  ["to.att.breakStart", "Start break", "开始休息"],
  ["to.att.breakEnd", "End break", "结束休息"],
  ["to.att.worked", "Worked {h}h {m}m", "已工作 {h} 小时 {m} 分"],
  ["to.att.shared", "Shared device: clock with your PIN", "共用设备：用 PIN 打卡"],
  ["to.att.sharedHint", "Enter your PIN, then choose clock in, break or clock out.", "输入您的 PIN，再选择上班、休息或下班。"],
  ["to.att.pin", "PIN", "PIN 码"],
  ["to.att.done", "{name}: {action} · {time}", "{name}：{action} · {time}"],
  ["to.att.today", "Today's attendance", "今日考勤"],
  ["to.att.none", "Nobody has clocked in yet.", "今天还没有人打卡。"],
  ["to.att.col.staff", "Staff", "员工"],
  ["to.att.col.in", "In", "上班"],
  ["to.att.col.out", "Out", "下班"],
  ["to.att.col.break", "Break", "休息"],
  ["to.att.col.worked", "Worked", "工时"],
  ["to.att.col.source", "How", "方式"],
  ["to.att.col.branch", "Location", "门店"],
  ["to.att.src.self", "Own login", "本人登录"],
  ["to.att.src.kiosk_pin", "PIN on shared device (old)", "共用设备 PIN（旧）"],
  ["to.att.src.manager", "Manager", "经理"],
  ["to.att.correct", "Correct", "更正"],
  ["to.att.correctTitle", "Correct shift · {name}", "更正班次 · {name}"],
  ["to.att.reason", "Reason (required)", "原因（必填）"],
  ["to.att.breakMin", "Break (minutes)", "休息（分钟）"],
  ["to.att.corrected", "Corrected: {reason}", "已更正：{reason}"],
  ["to.att.stillIn", "still in", "仍在班"],
  ["to.att.onBreakShort", "on break", "休息中"],
  ["to.att.min", "{n} min", "{n} 分钟"],
  ["to.att.webHint", "Read-only. Staff clock in and out on their own phone in the store app (GPS inside the shop); managers correct shifts there with a reason.", "只读。员工用自己的手机在门店 App 打卡（需在店内 GPS 范围），经理可在 App 中填写原因更正班次。"],
  ["to.att.date", "Date", "日期"],
  ["to.ph.title", "Work photos", "作品照"],
  ["to.ph.pick", "Choose the customer", "选择顾客"],
  ["to.ph.todays", "Today's appointments", "今日预约"],
  ["to.ph.mineToday", "My customers today", "我今天的顾客"],
  ["to.ph.search", "Search customers by name or phone", "按姓名或电话搜索顾客"],
  ["to.ph.change", "Change", "更换"],
  ["to.ph.visit", "Visit / service", "到店 / 服务"],
  ["to.ph.noVisit", "Not linked to a visit", "不关联到店"],
  ["to.ph.caption", "Caption (optional)", "说明（可选）"],
  ["to.ph.who", "Who can see it", "谁可以看到"],
  ["to.ph.internal", "Team only", "仅团队"],
  ["to.ph.customer", "Team + the customer (member area)", "团队 + 顾客（会员区）"],
  ["to.ph.public", "Also the salon website", "也可用于店铺网站"],
  ["to.ph.consentCheck", "The customer agreed that this photo may be shown on the salon website.", "顾客已同意此照片可在店铺网站展示。"],
  ["to.ph.publicManagersOnly", "Only the front desk or a manager can record website consent.", "只有前台或经理可以记录网站使用同意。"],
  ["to.ph.file", "Choose photo", "选择照片"],
  ["to.ph.uploading", "Uploading…", "上传中…"],
  ["to.ph.recent", "Photos of {name}", "{name} 的照片"],
  ["to.ph.staffHint", "You can add photos for customers you served today.", "您可以为今天服务过的顾客添加照片。"],
  ["to.ph.noneToday", "No appointments today.", "今天没有预约。"],
  ["to.cash.today", "Today by payment method", "今日各付款方式合计"],
  ["to.cash.total", "Taken today", "今日收款合计"],
  ["to.cash.package", "Package redeem", "配套使用"],
  ["to.cash.none", "No payments yet today.", "今天还没有收款。"],
  ["to.cash.count", "{n}×", "{n} 笔"],
  ["to.appt.onlyMe", "Only me", "只看我"],
  ["to.appt.everyone", "Everyone", "全部"],
  ["to.device.title", "This device", "本设备"],
  ["apiError.already_clocked_in", "Already clocked in. Clock out first.", "已上班打卡，请先下班打卡。"],
  ["apiError.not_clocked_in", "Not clocked in yet.", "尚未上班打卡。"],
  ["apiError.on_break", "Already on a break.", "已在休息中。"],
  ["apiError.not_on_break", "Not on a break.", "当前不在休息。"],
  ["apiError.bad_pin", "Wrong PIN.", "PIN 码错误。"],
  ["apiError.bad_time", "Check the times: clock-out must be after clock-in and not in the future.", "请检查时间：下班须晚于上班，且不能是未来时间。"],
] as const;

export type ToKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<ToKey, string>;

export const taskO = { en: col(1), zh: col(2), ms: col(1) };
